/* 1 boolean 1 2020-08-12 04:19:50.7528023 NULL 2 Multi Line Text 2 2020-09-29
20:07:31.6987553 NULL 3 Drop-down list 3 2021-03-08 21:17:03.8233333 NULL 4
Single Line Text 4 2021-03-11 21:28:25.7766666 NULL */

<template>
	<div>
		<pre>** {{ field.ResponseType }} ({{ field.ResponseTypeKey }}) **</pre>
		<!--------------------------- Boolean --------------------------->
		<div v-if="field.ResponseTypeKey == 1">
			<div class="bool-container">
				<div style="margin-bottom: 4px;">Please agree:</div>
				<div class="checkbox-flex">
					<div class="mr-2">
						<span class="check_ui">
							<input
								@click="handleBoolCheck"
								@change="validateField()"
								:checked="Response_Boolean"
								:id="
									'custom-field-' +
										field.ClientLocationCustomFieldKey +
										'-' +
										id
								"
								type="checkbox"
							/>
							<label
								:for="
									'custom-field-' +
										field.ClientLocationCustomFieldKey +
										'-' +
										id
								"
								:style="
									isError
										? 'border: 2px solid red; transition: none; box-shadow: none;'
										: ''
								"
							></label>
						</span>
					</div>
					<p style="width:100%;">
						<label
							class="text_size-medium"
							:for="
								'custom-field-' + field.ClientLocationCustomFieldKey + '-' + id
							"
						>
							{{ field.CustomFieldName }}
						</label>
						<span v-if="field.IsRequired">*</span>
						<br />
						<span class="tooltip" v-show="field.CustomFieldDesc">
							<a
								class="text_size-medium-small"
								href
								@click.prevent="triggerModal()"
								>Read more</a
							>
						</span>
					</p>
				</div>
				<div v-if="isError" class="text_size-small text_color-error">
					Required
				</div>
			</div>
			<pre>
Selected Bool: {{ Response_Boolean || 'null' }} ({{
					field.Response_Boolean || 'null'
				}})</pre
			>
		</div>
		<!--------------------------- Multi Line Text --------------------------->
		<div v-if="field.ResponseTypeKey == 2">
			<fieldset>
				<label
					class="text_size-medium"
					:for="'custom-field-' + field.ClientLocationCustomFieldKey + '-' + id"
				>
					{{ field.CustomFieldName }}
					<span v-if="field.IsRequired">*</span>
				</label>
				<textarea
					@blur="
						saveOrder();
						validateField();
					"
					rows="3"
					v-model="Response_Text"
					:class="{ 'border-red': isError }"
					:placeholder="field.CustomFieldDesc"
					:id="'custom-field-' + field.ClientLocationCustomFieldKey + '-' + id"
					style="resize: none;"
				/>

				<small
					v-if="isError"
					class="text_color-error text_size-small"
					style="display: block;"
					>Required</small
				>
			</fieldset>
			<pre>
Selected Text: {{ Response_Text || 'null' }} ({{
					field.Response_Text || 'null'
				}})</pre
			>
		</div>
		<!--------------------------- Drop-down list --------------------------->
		<div v-if="field.ResponseTypeKey == 3">
			<fieldset class="select">
				<label class="text_size-medium"
					>{{ field.CustomFieldName
					}}<span v-if="field.IsRequired">*</span></label
				>
				<select
					v-model="Selected_ClientLocationCustomFieldResponseKey"
					class="form-control form-control-lg custom-select"
					:class="{ 'border-red': isError }"
					:id="'custom-field-' + field.ClientLocationCustomFieldKey + '-' + id"
					:name="
						'custom-field-' + field.ClientLocationCustomFieldKey + '-' + id
					"
					@blur="validateField()"
					data-v-validate
					data-vv-rules="required|numeric"
					:placeholder="field.CustomFieldDesc"
					:style="
						Selected_ClientLocationCustomFieldResponseKey == null
							? 'color: #CCC;'
							: ''
					"
				>
					<option value="-1" disabled>{{ field.CustomFieldDesc }}</option>
					<template v-for="response in field.CustomFieldResponses">
						<option
							:key="
								'contact-info-heard-about-' +
									response.ClientLocationCustomFieldResponseKey
							"
							:value="response.ClientLocationCustomFieldResponseKey.toString()"
							>{{ response.ResponseLabel }}</option
						>
					</template>
				</select>

				<div v-if="isError" class="error" style="display: block;">Required</div>
			</fieldset>
			<pre>
Selected Values: {{
					Selected_ClientLocationCustomFieldResponseKey || 'null'
				}} / {{
					field.Selected_ClientLocationCustomFieldResponseKeys || 'null'
				}}</pre
			>
		</div>
		<!--------------------------- Single Line Text --------------------------->
		<div v-if="field.ResponseTypeKey == 4">
			<fieldset>
				<label
					class="text_size-medium"
					:for="'custom-field-' + field.ClientLocationCustomFieldKey + '-' + id"
				>
					{{ field.CustomFieldName }}<span v-if="field.IsRequired">*</span>
				</label>
				<div class="text_size-medium-small sublabel">
					{{ field.CustomFieldDesc }}
				</div>
				<input
					class="text_size-small"
					@blur="
						saveOrder();
						validateField();
					"
					type="text"
					v-model="Response_Text"
					:class="{
						'border-red': isError,
					}"
					:id="'custom-field-' + field.ClientLocationCustomFieldKey + '-' + id"
				/>

				<div v-if="isError" class="error" style="display: block;">Required</div>
			</fieldset>
			<pre>
Selected Text: {{ Response_Text || 'null' }} ({{
					field.Response_Text || 'null'
				}})</pre
			>
		</div>
		<!--------------------------- Multi-Select Drop-down list --------------------------->
		<div v-if="field.ResponseTypeKey == 5">
			<fieldset class="select text_size-medium">
				<label
					>{{ field.CustomFieldName }}?<span v-if="field.IsRequired"
						>*</span
					></label
				>
				<select
					multiple="true"
					@blur="
						saveOrder();
						validateField();
					"
					v-model="Selected_ClientLocationCustomFieldResponseKeys"
					class="form-control form-control-lg custom-select"
					:class="{ 'border-red': isError }"
					:id="'custom-field-' + field.ClientLocationCustomFieldKey + '-' + id"
					:name="
						'custom-field-' + field.ClientLocationCustomFieldKey + '-' + id
					"
					data-v-validate
					data-vv-rules="required|numeric"
					:placeholder="field.CustomFieldDesc"
					:style="
						Selected_ClientLocationCustomFieldResponseKeys == null
							? 'color: #CCC;'
							: ''
					"
				>
					<option :value="null" selected="selected" class="text_size-medium">{{
						field.CustomFieldDesc
					}}</option>
					<template v-for="response in field.CustomFieldResponses">
						<option
							class="text_size-medium"
							:key="
								'contact-info-heard-about-' +
									response.ClientLocationCustomFieldResponseKey
							"
							:value="response.ClientLocationCustomFieldResponseKey"
							>{{ response.ResponseLabel }}</option
						>
					</template>
				</select>

				<div v-if="isError" class="error" style="display: block;">Required</div>
			</fieldset>
			<pre>
Selected Values: {{
					Selected_ClientLocationCustomFieldResponseKey || 'null'
				}} / {{
					field.Selected_ClientLocationCustomFieldResponseKeys || 'null'
				}}</pre
			>
		</div>
		<!--------------------------- Modal --------------------------->
		<modal class="mr-2" v-if="modal.show" :modal="modal">
			<div class="text_size-medium" v-html="field.CustomFieldDesc"></div>
			<template v-slot:footer>
				<a @click.prevent="modalClick" class="button blue ml-1 mr-1">{{
					modalResponseBtnTxt
				}}</a>
			</template>
		</modal>
		<pre>Required: {{ field.IsRequired || 'false' }}</pre>
	</div>
</template>
<script>
	import { mapActions } from 'vuex';
	import CustomFieldHelpers from '@/mixins/customFieldHelpers';

	export default {
		props: ['field', 'formSubmitted'],
		mixins: [CustomFieldHelpers],
		created() {
			console.log(this.modalResponseBtnTxt);
			this.Response_Text = this.field.Response_Text;
			this.Response_Boolean = this.field.Response_Boolean;
			if (this.field.Selected_ClientLocationCustomFieldResponseKeys) {
				this.Selected_ClientLocationCustomFieldResponseKey = this.field.Selected_ClientLocationCustomFieldResponseKeys[0].toString();
				this.Selected_ClientLocationCustomFieldResponseKeys = this.field.Selected_ClientLocationCustomFieldResponseKeys.slice();
			}
		},
		data() {
			// We need to store these values locally so they are not overwritten when saveOrderProgress comes back
			return {
				isError: false,
				id: this._uid,
				Response_Boolean: null,
				Response_Text: null,
				Selected_ClientLocationCustomFieldResponseKey: -1,
				Selected_ClientLocationCustomFieldResponseKeys: null,
				modal: {
					show: false,
					shown: false,
				},
			};
		},
		computed: {
			modalResponseBtnTxt() {
				if (this.field.ResponseTypeKey == 1) {
					let resTrue = this.field.CustomFieldResponses.find(
						(r) => r.Response_Boolean == true
					);
					if (resTrue) return resTrue.ResponseLabel;
				}
				return 'I Agree';
			},
		},
		methods: {
			...mapActions(['saveOrderProgress']),
			saveOrder() {
				this.refreshValue();
				this.saveOrderProgress();
			},
			handleBoolCheck(e) {
				// show modal if not already shown AND if there is modal content
				// otherwise check checkbox
				if (!this.modal.shown && this.field.CustomFieldDesc) {
					this.triggerModal();
					e.preventDefault();
				} else {
					this.Response_Boolean = !this.Response_Boolean;
				}
			},
			validateField() {
				this.isError = !this.customFieldIsValid(this.field);
				return this.isError;
			},
			triggerModal() {
				this.modal.show = true;
				this.modal.shown = true;
			},
			modalClick() {
				this.Response_Boolean = true;
				this.modal.show = false;
			},
			refreshValue() {
				switch (this.field.ResponseTypeKey) {
					case 1:
						this.$set(this.field, 'Response_Boolean', this.Response_Boolean);
						break;
					case (2, 4):
						this.$set(this.field, 'Response_Text', this.Response_Text);
						break;
					case 3:
						this.$set(
							this.field,
							'Selected_ClientLocationCustomFieldResponseKeys',
							[this.Selected_ClientLocationCustomFieldResponseKey]
						);
						break;
					case 5:
						this.$set(
							this.field,
							'Selected_ClientLocationCustomFieldResponseKeys',
							this.Selected_ClientLocationCustomFieldResponseKeys
						);
						break;
					default:
						break;
				}
			},
		},
		watch: {
			Response_Boolean() {
				this.saveOrder();
			},
			Response_Text(val) {
				this.$set(this.field, 'Response_Text', val);
			},
			Selected_ClientLocationCustomFieldResponseKey(val) {
				if (val) {
					this.saveOrder();
				}
			},
			Selected_ClientLocationCustomFieldResponseKeys(val) {
				if (val) {
					this.saveOrder();
				}
			},
		},
	};
</script>
<style lang="scss">
	.sublabel {
		color: #9e9e9e;
		padding: 0 0 4px;
	}

	.bool-container {
		display: grid;
		grid-auto-flow: row;
		// font-size: 14px;
	}

	.error {
		color: #ff0000;
		font-size: 12px;
		padding-top: 5px;
	}
</style>
